import { CrudModel } from './_crud';

export class CompanyModel extends CrudModel {
	constructor() {
		super('admin/company');
	}
}

export default new CompanyModel();
